import kitchenCorner from "./../components/Icons/kitchenCorner.png";
import kitchenStraight from "./../components/Icons/kitchenStraight.png";
import kitchensStages3 from "./../components/Icons/3.png";
import kitchensStages2 from "./../components/Icons/2.png";
import kitchensStages1 from "./../components/Icons/1.png";
import kitchensStages4 from "./../components/Icons/4.png";

export const stats = [
    {id: 1, header: "20+", text: "лет на рынке (с 2002 года)"},
    {id: 2, header: "10 000+", text: "реализованных проектов"},
    {id: 3, header: "2500+", text: "постоянных клиентов"},
]

export const stages = [
    {
        id: 1,
        header: "Выбор шаблона",
        text: [
            {id: 1, text: "Выберите один из базовых шаблонов в качестве основы."},
            {id: 2, text: "Наши дизайнеры уже подготовили гармоничные решения, в которых учтены правила эргономики и стиля."},
        ],
        img: kitchensStages3
    },
    {
        id: 2,
        header: "Гибкая настройка размеров",
        text: [
            {id: 3, text: "Меняйте размеры доступных шкафов там, где это необходимо."},
            {id: 4, text: "Вы справитесь даже без опыта и специальных знаний."},
            {id: 5, text: "Исключена возможность ошибки. Система сама подскажет, какие элементы можно адаптировать без потери прочности изделия."},
        ],
        img: kitchensStages2
    },
    {
        id: 3,
        header: "Технический аудит и подтверждение",
        text: [
            {id: 6, text: "Ваш проект проверяет искусственный интеллект, а не человек. ИИ мгновенно анализирует конструктив, готовит точные чертежи и документацию, полностью исключая риск «человеческого фактора» и ошибок."},
            {id: 7, text: "Менеджер перезвонит, чтобы ещё раз уточнить с вами детали и заключить договор."},
        ],
        img: kitchensStages1
    },
    {
        id: 4,
        header: "Автоматизированное производство",
        text: [
            {id: 8, text: "После согласования и оплаты чертежи отправляются на станки с ЧПУ."},
            {id: 9, text: "Процесс изготовления полностью автоматизирован. Высококлассная техника обеспечивает идеальную подгонку деталей."},
        ],
        img: kitchensStages4
    },
    {
        id: 5,
        header: "Безопасная транспортировка",
        text: [
            {id: 10, text: "Мы бережно упаковываем каждую деталь и доставляем ваш заказ в специальной защитной упаковке, гарантируя сохранность всех поверхностей."},
        ],
    },
]
export const advantages = [
    {
        id: 1,
        header: "Простота",
        text: "Для заказа не требуются специальные знания и навыки. Вы сразу видите, как изменение количества шкафов влияет на общие размеры и финальную смету."
    },
    {
        id: 2,
        header: "Качество",
        text: "Использование шаблонов и автоматизация помогли сохранить высокое качество производства и исключить ошибки."
    },
    {
        id: 3,
        header: "Скорость",
        text: "Автоматизация процессов при разработке документации и производстве помогают снизить сроки изготовления заказа до 1,5-2 недель."
    }]
export const kitchensStraight = [
    {
        "id": 1,
        "name": "kitchens_1",
        "relativeUrl": kitchenStraight,
        "priority": 1,
        description: "Описание в 2 строки",
        type: "Прямая",
        body: "Egger",
        front: "Egger + МДФ в эмали",
        lengthLeft: 2300,
        lengthRight: 1200,
        height: 2750,
        price: 2250,
        discount: true,
        discountAmount: 50,
        top: true
    },
    {
        "id": 3,
        "name": "kitchens_3",
        "relativeUrl": kitchenStraight,
        "priority": 3,
        description: "Шкафы размещены под углом, имеется угловой модуль стандартного размера.",
        type: "Прямая",
        body: "Egger",
        front: "Egger + МДФ в эмали",
        lengthLeft: 2300,
        lengthRight: 1200,
        height: 2750,
        price: 2500,
        discount: false,
        discountAmount: 0,
        top: true
    },
    {
        "id": 2,
        "name": "kitchens_2",
        "relativeUrl": kitchenStraight,
        "priority": 2,
        description: "Шкафы размещены под углом, имеется угловой модуль стандартного размера.",
        type: "Прямая",
        body: "Egger",
        front: "Egger + МДФ в эмали",
        lengthLeft: 2300,
        lengthRight: 1200,
        height: 2750,
        price: 2500,
        discount: false,
        discountAmount: 0,
        top: true
    },
    {
        "id": 4,
        "name": "kitchens_1",
        "relativeUrl": kitchenStraight,
        "priority": 1,
        description: "Описание в 2 строки",
        type: "Прямая",
        body: "Egger",
        front: "Egger + МДФ в эмали",
        lengthLeft: 2300,
        lengthRight: 1200,
        height: 2750,
        price: 2500,
        discount: false,
        discountAmount: 0,
        top: true
    },
    {
        "id": 5,
        "name": "kitchens_3",
        "relativeUrl": kitchenStraight,
        "priority": 3,
        description: "Шкафы размещены под углом, имеется угловой модуль стандартного размера.",
        type: "Прямая",
        body: "Egger",
        front: "Egger + МДФ в эмали",
        lengthLeft: 2300,
        lengthRight: 1200,
        height: 2750,
        price: 2500,
        discount: false,
        discountAmount: 0,
        top: true
    },
    {
        "id": 6,
        "name": "kitchens_2",
        "relativeUrl": kitchenStraight,
        "priority": 2,
        description: "Шкафы размещены под углом, имеется угловой модуль стандартного размера.",
        type: "Прямая",
        body: "Egger",
        front: "Egger + МДФ в эмали",
        lengthLeft: 2300,
        lengthRight: 1200,
        height: 2750,
        price: 2500,
        discount: false,
        discountAmount: 0,
        top: true
    },
]
export const kitchensCorner = [
    {
        "id": 1,
        "name": "kitchens_1",
        "relativeUrl": kitchenCorner,
        "priority": 1,
        description: "Описание в 2 строки",
        type: "Угловая",
        body: "Egger",
        front: "Egger + МДФ в эмали",
        lengthLeft: 2300,
        lengthRight: 1200,
        height: 2750,
        price: 2250,
        discount: true,
        discountAmount: 50,
        top: false
    },
    {
        "id": 3,
        "name": "kitchens_3",
        "relativeUrl": kitchenCorner,
        "priority": 3,
        description: "Шкафы размещены под углом, имеется угловой модуль стандартного размера.",
        type: "Угловая",
        body: "Egger",
        front: "Egger + МДФ в эмали",
        lengthLeft: 2300,
        lengthRight: 1200,
        height: 2750,
        price: 2500,
        discount: false,
        discountAmount: 0,
        top: false
    },
    {
        "id": 2,
        "name": "kitchens_2",
        "relativeUrl": kitchenCorner,
        "priority": 2,
        description: "Шкафы размещены под углом, имеется угловой модуль стандартного размера.",
        type: "Угловая",
        body: "Egger",
        front: "Egger + МДФ в эмали",
        lengthLeft: 2300,
        lengthRight: 1200,
        height: 2750,
        price: 2500,
        discount: false,
        discountAmount: 0,
        top: false
    },
    {
        "id": 1,
        "name": "kitchens_1",
        "relativeUrl": kitchenCorner,
        "priority": 1,
        description: "Описание в 2 строки",
        type: "Угловая",
        body: "Egger",
        front: "Egger + МДФ в эмали",
        lengthLeft: 2300,
        lengthRight: 1200,
        height: 2750,
        price: 2500,
        discount: false,
        discountAmount: 0,
        top: false
    },
    {
        "id": 3,
        "name": "kitchens_3",
        "relativeUrl": kitchenCorner,
        "priority": 3,
        description: "Шкафы размещены под углом, имеется угловой модуль стандартного размера.",
        type: "Угловая",
        body: "Egger",
        front: "Egger + МДФ в эмали",
        lengthLeft: 2300,
        lengthRight: 1200,
        height: 2750,
        price: 2500,
        discount: false,
        discountAmount: 0,
        top: false

    },
    {
        "id": 2,
        "name": "kitchens_2",
        "relativeUrl": kitchenCorner,
        "priority": 2,
        description: "Шкафы размещены под углом, имеется угловой модуль стандартного размера.",
        type: "Угловая",
        body: "Egger",
        front: "Egger + МДФ в эмали",
        lengthLeft: 2300,
        lengthRight: 1200,
        height: 2750,
        price: 2500,
        discount: false,
        discountAmount: 0,
        top: false
    },
]
export const news = [
    {
        id: 1,
        img: kitchenStraight,
        localDate: "2026-03-19",
        text: "С удовольствием делимся с вами захватывающими новостями!",
        description: "Мы представляем обновленный проект «UpMe».Давайте поближепознакомимся сданным проектом.Задайтесебе нескольковопросов:Ценители высовременные иинновационные решения ? Устали ждатькухню месяцами ?Мечтаете окухне,но бюджетограничен? "
    },
    {
        id: 2,
        img: kitchenStraight,
        localDate: "2026-03-19",
        text: "Особенности встроенного холодильника",
        description: "С точки зрения внешнего вида существуют частично и полностью встроенные холодильники.\n" +
            "Частичные не решают проблему внешнего вида, но создают целостность гарнитура. Холодильник встраивается в нишу, это избавляет от больших отступов, где скапливается пыль, а вокруг холодильника можно добавить модули, которые будут его как бы обтекать. Это хороший вариант, если цвет устройства подходит под цвет фасадов, и не хватает именно общности композиции."
    },
    {
        id: 3,
        img: kitchenStraight,
        localDate: "2026-03-19",
        text: "Особенности встроенного холодильника",
        description: "С точки зрения внешнего вида существуют частично и полностью встроенные холодильники.\n" +
            "Частичные не решают проблему внешнего вида, но создают целостность гарнитура. Холодильник встраивается в нишу, это избавляет от больших отступов, где скапливается пыль, а вокруг холодильника можно добавить модули, которые будут его как бы обтекать. Это хороший вариант, если цвет устройства подходит под цвет фасадов, и не хватает именно общности композиции."
    }]
export const questions = [
    {
        id: 1,
        header: "Можно ли самостоятельно заказать кухню без опыта проектирования?",
        content: [
            {
                type: "paragraph",
                parts: [
                    {text: "Да, заказать кухню "},
                    {text: "без специальных знаний в проектировании", bold: true},
                    {text: "вполне возможно! Наши "},
                    {text: "кухонные шаблоны", bold: true},
                    {text: " разработаны с учётом удобства и "},
                    {text: "защиты от ошибок", bold: true},
                    {text: " — их конструкция исключает несоответствие размеров и некорректные комбинации модулей."},
                ],
            },
            {
                type: "paragraph",
                parts: [
                    {text: "Как это работает: ", italic: true},
                ],
            },
            {
                type: "list",
                items: [
                    {
                        parts: [
                            {text: "Автоматическая корректировка", bold: true},
                            {text: " — при изменении одного модуля система "},
                            {text: "подгоняет ширину связанных элементов", bold: true},
                            {text: ", сохраняя гармоничность и функциональность."},
                        ],
                    },
                    {
                        parts: [
                            {text: "Ограничения по изменению", bold: true},
                            {text: " — некоторые модули "},
                            {text: "заблокированы от редактирования", bold: true},
                            {text: ", чтобы предотвратить ошибки, например, несоответствие по высоте или расположению."},
                        ],
                    },
                    {
                        parts: [
                            {text: "Проверка на этапе оформления", bold: true},
                            {text: " — перед заказом система "},
                            {text: "анализирует проект на корректность", bold: true},
                            {text: ", сигнализируя, если есть потенциальные проблемы."},
                        ],
                    },
                ],
            },
            {
                type: "paragraph",
                parts: [
                    {text: "Таким образом, вы можете "},
                    {text: "беспрепятственно подобрать модули", bold: true},
                    {text: " под свои параметры кухни, не боясь ошибок в расстановке и соединении элементов."},
                ],
            },
        ],
    },
    {
        id: 2,
        header: "Я могу выбрать любую длину кухни?",
        content: [
            {
                type: "paragraph",
                parts: [
                    {text: "Каждый кухонный модуль (шкаф) имеет фиксированные пределы по ширине: минимальную и максимальную. При этом общий размер кухни определяется суммой ширины всех её модулей.", bold: true},
                ],
            },
            {
                type: "list",
                items: [
                    {
                        parts: [
                            {text: "Минимальный размер кухни", bold: true},
                            {text: " рассчитывается как сумма минимальных ширины всех модулей."},
                        ],
                    },
                    {
                        parts: [
                            {text: "Максимальный размер кухни", bold: true},
                            {text: " — это сумма максимальных ширины всех модулей."},
                        ],
                    },
                ],
            },
            {
                type: "paragraph",
                parts: [
                    {text: "Важно:", italic: true},
                    {text: " каждый модуль можно индивидуально настроить в пределах своих минимальных и максимальных параметров, что позволяет оптимизировать итоговую ширину кухни под ваши нужды. Итоговый размер кухни в конструкторе будет показан с учётом всех изменений."},
                ],
            },
        ],
    },
    {
        id: 3,
        header: "А если я хочу шкаф нестандартной ширины?",
        content: [
            {
                type: "paragraph",
                parts: [
                    {text: "Если вам необходим", bold: true},
                    {text: " модуль (кухонный шкаф) "},
                    {text: "нестандартной ширины, учитывайте, что каждый модуль (шкаф) имеет следующие ограничения:", bold: true},
                ],
            },
            {
                type: "list",
                items: [
                    {
                        parts: [
                            {text: "Размер можно настроить "},
                            {text: "индивидуально для каждого модуля", bold: true},
                            {text: " в пределах "},
                            {text: "минимальной и максимальной ширины.", bold: true},
                        ],
                    },
                    {
                        parts: [
                            {text: "Точность настройки:", bold: true},
                            {text: " ширина изменяется с шагом "},
                            {text: "1 мм", bold: true},
                            {text: ", что позволяет подобрать оптимальные размеры под вашу кухню."},
                        ],
                    },
                ],
            },
            {
                type: "paragraph",
                parts: [
                    {text: "Таким образом, если необходимый размер входит в диапазон допустимых значений для модуля, его всегда можно настроить с требуемой точностью."},
                ],
            },
        ],
    },
    {
        id: 4,
        header: "Почему цена изменяется при изменении модуля?",
        content: [
            {
                type: "paragraph",
                parts: [
                    {text: "Цена кухни обновляется автоматически при изменении размеров или комплектации модулей по следующим причинам:", bold: true},
                ],
            },
            {
                type: "list",
                items: [
                    {
                        parts: [
                            {text: "Зависимость стоимости от размеров:\n", bold: true},
                            {text: "Цена каждого модуля рассчитывается "},
                            {text: "индивидуально", bold: true},
                            {text: " с учётом его "},
                            {text: "точной ширины, высоты, глубины и используемых материалов", bold: true},
                            {text: "."},
                        ],
                    },
                    {
                        parts: [
                            {text: "Влияние комплектации:\n", bold: true},
                            {text: "Изменение размеров может повлиять на "},
                            {text: "необходимость дополнительных элементов", bold: true},
                            {text: " (например, крепёжных деталей, наполнителей или отделки), что также отражается на итоговой цене."},
                        ],
                    },
                    {
                        parts: [
                            {text: "Точный расчёт системы:\n", bold: true},
                            {text: "Программа учитывает "},
                            {text: "прямые и косвенные затраты", bold: true},
                            {text: ", включая логистику и работу мастеров, поэтому итоговая стоимость формируется "},
                            {text: "автоматически и динамически", bold: true},
                            {text: " при каждом изменении параметров."},
                        ],
                    },
                ],
            },
            {
                type: "paragraph",
                parts: [
                    {text: "Так вы сразу видите, как "},
                    {text: "конкретный шкаф", bold: true},
                    {text: " влияет на бюджет проекта."},
                ],
            },
        ],
    },
    {
        id: 5,
        header: "Можно ли заказать шкафы (модули) без столешницы?",
        content: [
            {
                type: "paragraph",
                parts: [
                    {text: "Автоматизированная система "},
                    {text: "по умолчанию предполагает наличие столешниц", bold: true},
                    {text: " для каждого модуля, так как они являются стандартным элементом комплектации кухни."},
                ],
            },
            {
                type: "paragraph",
                parts: [
                    {text: "Однако возможны исключения по согласованию:", bold: true},
                ],
            },
            {
                type: "list",
                items: [
                    {
                        parts: [
                            {text: "Индивидуальный заказ", bold: true},
                            {text: " — если вам не нужна столешница на определённом модуле (например, для бытовой техники, ниш или декоративных элементов), это "},
                            {text: "можно организовать по предварительному уточнению с менеджером", bold: true},
                            {text: "."},
                        ],
                    },
                    {
                        parts: [
                            {text: "Условия:", bold: true},
                            {text: " такое решение требует "},
                            {text: "дополнительного согласования", bold: true},
                            {text: " с учетом особенностей проекта, чтобы избежать проблем с монтажом или дизайном кухни."},
                        ],
                    },
                ],
            },
            {
                type: "paragraph",
                parts: [
                    {text: "Рекомендация:", bold: true},
                    {text: " свяжитесь с менеджером для уточнения деталей и возможных корректировок в проекте."},
                ],
            },
        ],
    },
]